/**
 * @generated SignedSource<<833852bc3ddd9a91a710ff19c2d356a2>>
 * @relayHash bfe07c4627cdf47f030bff23909d7190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a

import type { ConcreteRequest } from 'relay-runtime';
export type ForgeObservabilityPublishFrontendCustomMetricInput = {
  appId: string;
  contextAri: string;
  customMetricName: string;
  installationId: string;
  moduleKey: string;
  value?: number | null;
};
export type emitFrontendCustomMetricMutation$variables = {
  input: ForgeObservabilityPublishFrontendCustomMetricInput;
};
export type emitFrontendCustomMetricMutation$data = {
  readonly ecosystem: {
    readonly forgeObservability: {
      readonly publishFrontendCustomMetric: {
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type emitFrontendCustomMetricMutation = {
  response: emitFrontendCustomMetricMutation$data;
  variables: emitFrontendCustomMetricMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "EcosystemMutation",
    "kind": "LinkedField",
    "name": "ecosystem",
    "plural": false,
    "selections": [
      {
        "concreteType": "ForgeObservabilityMutation",
        "kind": "LinkedField",
        "name": "forgeObservability",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "ForgeObservabilityPublishFrontendCustomMetricResponse",
            "kind": "LinkedField",
            "name": "publishFrontendCustomMetric",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "emitFrontendCustomMetricMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emitFrontendCustomMetricMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9f6f405334e912ac423e5472ae733bed876222fcd844be006c0a9c718a6d4c9a",
    "metadata": {},
    "name": "emitFrontendCustomMetricMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0525b01263b0e23397f5287e835f1eb4";

export default node;
